const DIRECT_OUTCOME_PAGE_KEYS = new Set([
  'journal',
  'goals',
  'evaluation',
  'inspiration',
  'quickadvice'
]);

const DIRECT_OUTCOME_ROUTES = new Set([
  '/app/journal',
  '/app/goals',
  '/app/evaluation',
  '/app/inspiration',
  '/app/quickadvice',
  '/app/challenges',
  '/app/gift',
  '/app/quiz',
  '/app/recommendations',
  '/app/earth',
  '/app/water',
  '/app/air',
  '/app/fire',
  '/app/reminders',
  '/app/insights',
  '/app/insightsandreminders'
]);

const ROUTE_FAMILY_ALIASES = new Map([
  ['/app/insights', 'insights_reminders'],
  ['/app/reminders', 'insights_reminders'],
  ['/app/insightsandreminders', 'insights_reminders']
]);

function normalizePath(value = '') {
  const text = String(value || '').trim();
  if (!text) return '';
  const [pathname] = text.split('?');
  return pathname.replace(/\/+$/, '').toLowerCase() || '';
}

function resolveRouteFamily(path = '') {
  const normalized = normalizePath(path);
  return ROUTE_FAMILY_ALIASES.get(normalized) || normalized || null;
}

export function shouldEmitImplicitMissionOutcome({
  missionData = null,
  currentPath = '',
  pageKey = 'other'
} = {}) {
  if (!missionData || missionData.fromJourneyGuide !== true) return false;

  const normalizedCurrentPath = normalizePath(currentPath);
  if (!normalizedCurrentPath.startsWith('/app/')) return false;
  if (normalizedCurrentPath === '/app/journey-guide') return false;

  const normalizedMissionRoute = normalizePath(missionData.missionRoute || '');
  const normalizedPageKey = String(pageKey || '').trim().toLowerCase() || 'other';

  if (normalizedMissionRoute && normalizedMissionRoute === normalizedCurrentPath) {
    return true;
  }

  if (
    normalizedMissionRoute
    && resolveRouteFamily(normalizedMissionRoute)
    && resolveRouteFamily(normalizedMissionRoute) === resolveRouteFamily(normalizedCurrentPath)
  ) {
    return true;
  }

  if (DIRECT_OUTCOME_ROUTES.has(normalizedCurrentPath)) {
    return true;
  }

  if (DIRECT_OUTCOME_PAGE_KEYS.has(normalizedPageKey)) {
    return true;
  }

  return false;
}

export function getImplicitMissionOutcomeEventType(durationMs = 0) {
  const safeDuration = Math.max(0, Number(durationMs) || 0);
  return safeDuration >= 30000 ? 'implicit_completed' : 'abandoned';
}
